import { createSelector } from 'reselect';
import createCachedSelector from 're-reselect';
import flatMap from 'lodash/flatMap';
import find from 'lodash/find';

const allIds = state => state.entities.inspectionType.allIds;
const byId = state => state.entities.inspectionType.byId;

export const getAllInspectionTypes = createSelector(
  [allIds, byId],
  (ids, inspectionTypes) => {
    return ids.map(id => inspectionTypes[id]);
  }
);

export const getAllAvailableTypesForList = createSelector(
  [getAllInspectionTypes],
  types => {
    if (types.length === 0) return [];
    return flatMap(types, type => {
      return type.availableTypes.map(availableType => {
        return {
          brandId: type.key,
          typeId: availableType.key,
          label: `${type.label} ${availableType.label}`,
          imgSrc: `/img/brandtypes/${type.key}.${availableType.key}.png`,
        };
      });
    });
  }
);

/* eslint-disable no-sequences */
export const getNewInspectionTitleForBrandType = createCachedSelector(
  getAllInspectionTypes,
  (state, brandId) => brandId,
  (state, brandId, typeId) => typeId,
  (brands, brandId, typeId) => {
    const brand = find(brands, { key: brandId });
    if (!brand) return '';
    const type = find(brand.availableTypes, { key: typeId });
    if (!type) return '';
    return `${brand.label} ${type.label}`;
  }
)((state, brandId, typeId) => (brandId, typeId));

/* eslint-disable no-sequences */
export const getInspectionTitle = createCachedSelector(
  getAllInspectionTypes,
  (state, inspectionId) => inspectionId,
  (brands, inspectionId) => {
    const parts = inspectionId.split('.');
    if (parts.length !== 3) {
      throw new Error('invalid inspectionid: ' + inspectionId);
    }
    const brand = find(brands, { key: parts[0] });
    if (!brand) return '';
    const type = find(brand.availableTypes, { key: parts[1] });
    if (!type) return '';
    const inspection = find(type.availableInspections, { key: parts[2] });
    return type.label + ': ' + brand.label + ' – ' + inspection.label.toLowerCase();
  }
)((state, inspectionId) => inspectionId);

/* eslint-disable no-sequences */
export const getInspectionsForBrandType = createCachedSelector(
  getAllInspectionTypes,
  (state, brandId) => brandId,
  (state, brandId, typeId) => typeId,
  (brands, brandId, typeId) => {
    const brand = find(brands, { key: brandId });
    if (!brand) return [];
    const type = find(brand.availableTypes, { key: typeId });
    if (!type) return [];
    return type.availableInspections || [];
  }
)((state, brandId, typeId) => (brandId, typeId));



// WEBPACK FOOTER //
// ./src/modules/inspectionType/inspectionType.selectors.js